import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getConfigurationDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  users: [
    {
      fieldName: "User Name",
      fieldValue: "userName",
      className: "col-span-6",
      type: "text",
      name: "userName",
      formType: "input",
      label: "User Name",
      placeholder: "Enter User Name",
      validation: { required: "User Name is required" },
    },
    {
      fieldName: "Name",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name",
      placeholder: "Enter Name",
      validation: { required: "Name is required" },
    },
    {
      fieldName: "Email",
      fieldValue: "email",
      className: "col-span-6",
      type: "text",
      name: "email",
      formType: "input",
      label: "Email",
      placeholder: "Enter Email",
      validation: { required: "Email is required" },
    },
    {
      fieldName: "Role",
      fieldValue: "role",
      className: "col-span-6",
      type: "text",
      name: "role",
      formType: "input",
      label: "Role",
      placeholder: "Enter Role",
      validation: { required: "Role is required" },
    },
    {
      fieldName: "Password",
      fieldValue: "password",
      className: "col-span-6",
      type: "text",
      name: "password",
      formType: "input",
      label: "Password",
      placeholder: "Enter Password",
      validation: { required: "Password is required" },
    },
  ],
  edmMailer: [
    {
      fieldName: "Title",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title",
      placeholder: "Enter Title",
      validation: { required: "Title is required" },
    },
    // {
    //   fieldName: "Name",
    //   fieldValue: "fromName",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "fromName",
    //   formType: "input",
    //   label: "Name",
    //   placeholder: "Enter Name",
    //   validation: { required: "Name is required" },
    // },
    // {
    //   fieldName: "Email",
    //   fieldValue: "fromMail",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "fromMail",
    //   formType: "input",
    //   label: "Email",
    //   placeholder: "Enter Email",
    //   validation: {
    //     required: "Email is required",
    //     pattern: {
    //       value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    //       message: "Please enter a valid email address",
    //     },
    //   },
    // },
    {
      fieldName: "Subject",
      fieldValue: "subject",
      className: "col-span-6",
      type: "text",
      name: "subject",
      formType: "input",
      label: "Subject",
      placeholder: "Enter Subject",
      validation: { required: "Subject is required" },
    },
    {
      fieldName: "Description",
      fieldValue: "description",
      className: "col-span-6",
      type: "text",
      name: "description",
      formType: "richText",
      label: "Description",
      placeholder: "Enter Description",
      validation: { required: "Description is required" },
    },
    {
      fieldName: "Body",
      fieldValue: "body",
      className: "col-span-6",
      type: "text",
      name: "body",
      formType: "richText",
      label: "Body",
      placeholder: "Enter Body",
      validation: { required: "Body is required" },
    },
    // {
    //   fieldName: "Header",
    //   fieldValue: "header",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "header",
    //   formType: "richText",
    //   label: "Header",
    //   placeholder: "Enter Header",
    //   validation: { required: "Header is required" },
    // },
    // {
    //   fieldName: "Footer",
    //   fieldValue: "footer",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "footer",
    //   formType: "richText",
    //   label: "Footer",
    //   placeholder: "Enter Footer",
    //   validation: { required: "Footer is required" },
    // },
  ],
  promotions: [
    {
      fieldName: "Title",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title",
      placeholder: "Enter Title",
      validation: { required: "Title is required" },
    },
    // {
    //   fieldName: "Name",
    //   fieldValue: "fromName",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "fromName",
    //   formType: "input",
    //   label: "Name",
    //   placeholder: "Enter Name",
    //   validation: { required: "Name is required" },
    // },
    // {
    //   fieldName: "Email",
    //   fieldValue: "fromMail",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "fromMail",
    //   formType: "input",
    //   label: "Email",
    //   placeholder: "Enter Email",
    //   validation: {
    //     required: "Email is required",
    //     pattern: {
    //       value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    //       message: "Please enter a valid email address",
    //     },
    //   },
    // },
    {
      fieldName: "Subject",
      fieldValue: "subject",
      className: "col-span-6",
      type: "text",
      name: "subject",
      formType: "input",
      label: "Subject",
      placeholder: "Enter Subject",
      validation: { required: "Subject is required" },
    },
    {
      fieldName: "Description",
      fieldValue: "description",
      className: "col-span-6",
      type: "text",
      name: "description",
      formType: "richText",
      label: "Description",
      placeholder: "Enter Description",
      validation: { required: "Description is required" },
    },
    {
      fieldName: "Body",
      fieldValue: "body",
      className: "col-span-6",
      type: "text",
      name: "body",
      formType: "richText",
      label: "Body",
      placeholder: "Enter Body",
      validation: { required: "Body is required" },
    },
    // {
    //   fieldName: "Header",
    //   fieldValue: "header",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "header",
    //   formType: "richText",
    //   label: "Header",
    //   placeholder: "Enter Header",
    //   validation: { required: "Header is required" },
    // },
    // {
    //   fieldName: "Footer",
    //   fieldValue: "footer",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "footer",
    //   formType: "richText",
    //   label: "Footer",
    //   placeholder: "Enter Footer",
    //   validation: { required: "Footer is required" },
    // },
  ],
  newsLetter: [
    {
      fieldName: "Title",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title",
      placeholder: "Enter Title",
      validation: { required: "Title is required" },
    },
    // {
    //   fieldName: "Name",
    //   fieldValue: "fromName",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "fromName",
    //   formType: "input",
    //   label: "Name",
    //   placeholder: "Enter Name",
    //   validation: { required: "Name is required" },
    // },
    // {
    //   fieldName: "Email",
    //   fieldValue: "fromMail",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "fromMail",
    //   formType: "input",
    //   label: "Email",
    //   placeholder: "Enter Email",
    //   validation: {
    //     required: "Email is required",
    //     pattern: {
    //       value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    //       message: "Please enter a valid email address",
    //     },
    //   },
    // },
    {
      fieldName: "Subject",
      fieldValue: "subject",
      className: "col-span-6",
      type: "text",
      name: "subject",
      formType: "input",
      label: "Subject",
      placeholder: "Enter Subject",
      validation: { required: "Subject is required" },
    },
    {
      fieldName: "Description",
      fieldValue: "description",
      className: "col-span-6",
      type: "text",
      name: "description",
      formType: "richText",
      label: "Description",
      placeholder: "Enter Description",
      validation: { required: "Description is required" },
    },
    {
      fieldName: "Body",
      fieldValue: "body",
      className: "col-span-6",
      type: "text",
      name: "body",
      formType: "richText",
      label: "Body",
      placeholder: "Enter Body",
      validation: { required: "Body is required" },
    },
    // {
    //   fieldName: "Header",
    //   fieldValue: "header",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "header",
    //   formType: "richText",
    //   label: "Header",
    //   placeholder: "Enter Header",
    //   validation: { required: "Header is required" },
    // },
    // {
    //   fieldName: "Footer",
    //   fieldValue: "footer",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "footer",
    //   formType: "richText",
    //   label: "Footer",
    //   placeholder: "Enter Footer",
    //   validation: { required: "Footer is required" },
    // },
  ],
  notificationSettings: [
    {
      fieldName: "Name",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name",
      placeholder: "Enter Name",
      validation: { required: "Name is required" },
    },
    {
      fieldName: "Description",
      fieldValue: "description",
      className: "col-span-6",
      type: "text",
      name: "description",
      formType: "input",
      label: "Description",
      placeholder: "Enter Description",
      validation: { required: "Description is required" },
    },
    {
      fieldName: "Status",
      fieldValue: "enabled",
      className: "col-span-6",
      type: "text",
      name: "enabled",
      formType: "input",
      label: "Enabled",
      placeholder: "Enter Enabled",
      validation: { required: "Enabled is required" },
    },
    {
      fieldName: "Emails",
      fieldValue: "emails",
      className: "col-span-6",
      type: "text",
      name: "emails",
      formType: "input",
      label: "Emails",
      placeholder: "Enter Emails",
      validation: { required: "Emails is required" },
    },
  ],
};
